import React from "react";
import "./SolutionDetailsFeatures.css";

const features = [
  {
    title: "Exterior-Grade Sheathing Solution",
    desc: "Designed for external wall applications, providing a strong and stable backing for façade finishes.",
  },
  {
    title: "Moisture & Weather Protection",
    desc: "Works effectively with vapor barrier membranes to support moisture control and long-term durability.",
  },
  {
    title: "Fast & Efficient Installation",
    desc: "Direct screw-fixing to IRQ C-stud framing ensures quick installation and reduced labor time.",
  },
  {
    title: "Smooth Joint Treatment:",
    desc: "White cementitious joint compound provides clean joint finishing and a continuous surface.",
  },
  {
    title: "Improved Thermal Performance",
    desc: "Adds racking strength and rigidity Compatible with Rockwool / mineral insulation to enhance energy efficiency and reduce heat transfer. to the external frame",
  },
  {
    title: "Enhanced Acoustic Insulation",
    desc: "Mineral wool cavity insulation helps reduce external noise transmission into the building.",
  },
];

const toFeatureRows = (list) =>
  Array.isArray(list)
    ? list
        .map((f) => ({
          title: f?.title || "",
          desc: f?.description || f?.text || f?.body || f?.desc || "",
        }))
        .filter((f) => f.title || f.desc)
    : [];

const parseDetailsTextToFeatures = (detailsText) => {
  const text = String(detailsText || "").trim();
  if (!text) return [];

  return text
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean)
    .filter((line) => !/^key features(\s*&\s*benefits)?$/i.test(line))
    .map((line) => {
      const colonIndex = line.indexOf(":");
      if (colonIndex <= 0) {
        return { title: line, desc: "" };
      }
      return {
        title: line.slice(0, colonIndex).trim(),
        desc: line.slice(colonIndex + 1).trim(),
      };
    })
    .filter((f) => f.title || f.desc);
};

const SolutionDetailsFeatures = ({ solution, activeTabIndex = 0 }) => {
  const tabs = Array.isArray(solution?.descriptionTabs)
    ? [...solution.descriptionTabs].sort(
        (a, b) =>
          (typeof a?.displayOrder === "number" ? a.displayOrder : Number.MAX_SAFE_INTEGER) -
          (typeof b?.displayOrder === "number" ? b.displayOrder : Number.MAX_SAFE_INTEGER)
      )
    : [];
  const safeTabIndex =
    Number.isFinite(activeTabIndex) && activeTabIndex >= 0
      ? Math.min(activeTabIndex, Math.max(0, tabs.length - 1))
      : 0;
  const activeTab = tabs[safeTabIndex] || null;

  // Tab-specific features support (tab details text or explicit arrays).
  const tabDetailsFeatures = parseDetailsTextToFeatures(activeTab?.details);
  const tabFeatures = toFeatureRows(
    tabDetailsFeatures.length
      ? tabDetailsFeatures
      : activeTab?.features ||
      activeTab?.keyFeatures ||
      activeTab?.benefits ||
      (Array.isArray(solution?.featuresByTab) ? solution.featuresByTab[safeTabIndex] : null)
  );
  const defaultFeatures = toFeatureRows(solution?.features);
  const data = tabFeatures.length ? tabFeatures : defaultFeatures.length ? defaultFeatures : features;

  const featuresTag = solution?.featuresTag || "FEATURES AND BENEFITS";
  const featuresTitle = solution?.featuresTitle || "Key Features";
  const featuresTitleAccent = solution?.featuresTitleAccent || "and Benefits";

  return (
    <section className="featuresSection">
      <div className="featuresContainer">
        
        {/* TOP TAG */}
        <span className="featuresTag">{featuresTag}</span>

        {/* TITLE */}
        <h2 className="featuresTitle">
          {featuresTitle} <span>{featuresTitleAccent}</span>
        </h2>

        {/* GRID */}
        <div className="featuresGrid">
          {data.map((item, index) => (
            <div key={index} className="featureItem">
              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default SolutionDetailsFeatures;